import classNames from 'classnames';
import { ReactNode } from 'react';

import s from './FindPortal.module.scss';

interface Props {
  onClick: () => void;
  children: ReactNode;
  'data-testid'?: string;
}

// An action, not a navigation, so it stays a button while taking the auth screens' link style.
export const FindPortalLinkButton = ({ onClick, children, 'data-testid': testId }: Props) => (
  <button
    type="button"
    className={classNames('auth-layout__link auth-layout__link--center', s.linkButton)}
    data-testid={testId}
    onClick={onClick}
  >
    {children}
  </button>
);
